import request from 'superagent'
import { useMutation } from 'react-query'
import { getApiServer } from '../../utils/domain'
import { CustomHttpError } from '../../types/CustomHttpError'

export default function useForgotLogin() {
  return useMutation(
    (values: any) => request.post(`${getApiServer()}/auth/forgot-login`).set('Accept', 'application/json').send(values).then((res) => res.body), {
    onError: (error: CustomHttpError) => {
      return error.response.text
    }
  }
  )
}